import { background, color, extendTheme } from '@chakra-ui/react';

const activeLabelStyles = {
  transform: 'scale(0.86) translateY(-24px)',
};

export const theme = extendTheme({
  fonts: {
    body: `'Pretendard', sans-serif`, // Set the body font to Pretendard
    heading: `'Pretendard', sans-serif`, // Set the heading font to Pretendard
  },
  components: {
    Form: {
      variants: {
        floating: {
          container: {
            _focusWithin: {
              label: {
                ...activeLabelStyles,
                background: 'White',
              },
            },
            'input:not(:placeholder-shown) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown) ~ label':
              {
                ...activeLabelStyles,
              },
            label: {
              top: 0,
              left: 0,
              zIndex: 2,
              position: 'absolute',
              pointerEvents: 'none',
              color: 'black',
              mx: 3,
              px: 1,
              my: 2,
              transformOrigin: 'left top',
            },
          },
        },
      },
    },
  },
});
